import { ProductOptionInterface, ProductVariantSizeColorInterface } from '@qlevr/shared/interfaces';
import isEmpty from 'lodash.isempty';

export function getFilteredOptions(
  options: ProductOptionInterface[] | null,
  selectedOptions: ProductVariantSizeColorInterface | null,
): [string, string][] | null {
  if (!selectedOptions || isEmpty(selectedOptions)) return null;

  return Object.entries(selectedOptions).filter(
    ([key, value]) =>
      typeof value === 'string' &&
      options?.some((option) => option.name.toLowerCase() === key && option.values.includes(value)),
  ) as [string, string][];
}
